import React from 'react';
import styles from 'componets/loading-card/index.module.scss';

const LoadingCard = ({ className = '', style }) => {
  return <div className={`${styles.loadingMochi} ${className}`} style={style} />;
};

export default LoadingCard;
